import SuccessActionType from '../../common/SuccessActionType';

const initialState = {
  plan: {},
  contract: '',
  partner: '',
  validatedPromoCode: false
};

const SuccessReducer = (state = initialState, action) => {
  switch (action.type) {
    case SuccessActionType.STORE_SIGNUP_SUCCESS_PLAN: {
      return { ...state, plan: action.plan };
    }
    case SuccessActionType.STORE_SIGNUP_CONTRACT: {
      return { ...state, contract: action.contract };
    }
    case SuccessActionType.STORE_VALIDATED_PROMO_CODE: {
      return { ...state, validatedPromoCode: action.validatedPromoCode };
    }
    case SuccessActionType.STORE_TRACKING_ID: {
      return { ...state, trackingId: action.trackingId };
    }
    case SuccessActionType.STORE_PARTNER: {
      return { ...state, partner: action.partner };
    }
    case SuccessActionType.RESET_ALL: {
      return initialState;
    }
    default:
      return state;
  }
};

export default SuccessReducer;

export const SuccessSelector = {
  getPlan: state => state.success.plan,
  getContract: state => state.success.contract,
  getPartner: state => state.success.partner,
  getValidatedPromoCode: state => state.success.validatedPromoCode
};



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/SuccessReducer.js
 **/